<template>
  <div class="c-modal">
    <div class="c-modal__cnt">
      <h4 class="c-modal__title text-primary">{{ $t("Attenzione!") }}</h4>
      <div class="c-modal__description">
        {{
          $t(
            "Uscendo dalla missione, perderai tutte le risposte date finora e dovrai ricominciare da capo"
          )
        }}
      </div>
      <button
        type="button"
        class="btn btn-primary c-modal__btn"
        @click="$emit('action')"
      >
        {{ $t("Conferma") }}
      </button>
      <div class="c-modal__cancel text-primary" @click="$emit('cancel')">
        {{ $t("Annulla") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal"
};
</script>

<style lang="scss" scoped>
.c-modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(235, 235, 235, 0.59);
  padding: 30px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.c-modal__cnt {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #fff;
  padding: 20px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 13px 30px 0 #dedede;
  border-radius: 10px;
  @media (min-width: 767px) {
    padding: 35px 50px;
    max-width: 600px;
  }
  @media (min-width: 992px) {
    padding: 65px 150px;
    max-width: 700px;
  }
}
.c-modal__title {
  font-weight: bold;
  font-size: 25px;
  margin-bottom: 15px;
}
.c-modal__description {
  color: #9a9a9a;
  font-size: 18px;
  margin-bottom: 30px;
}
.c-modal__btn {
  padding: 6px 25px;
  border-radius: 10px;
  margin-bottom: 20px;

  font-weight: bold;
  font-size: 18px;
  color: #fff;
}

.c-modal__cancel {
  text-decoration: underline;
  cursor: pointer;
}
</style>
